import { ROUTE } from "../../../routes";
import { ButtonTypeTokens, } from "@voltmoney/schema";
import SharedPropsService from "../../../SharedPropsService";
import _ from "lodash";
import { portfolioListDatastoreBuilderV2, togglePortfolio } from "./utils";
import { addCommasToNumber, allowDynamicLimitFromBE, removeCommasFromNumber, roundDownToNearestHundred, } from "../../../configs/utils";
import { getDesiredValue } from "../portfolio_readonly/actions";
import { api } from "../../../configs/api";
import { getAppHeader } from "../../../configs/config";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { ACTION } from "../../afterUnlock/confirm_amount/types";
import { MIN_LIMIT } from "../../../configs/constants";
let portfolioSearchKeyword = "";
let listBeforeSearchUI = [];
export const getTotalLimit = (availableCAS, isinNavMap, isinLTVMap) => {
    let sum = 0;
    availableCAS.forEach((item) => {
        sum =
            sum +
                roundDownToNearestHundred(item.pledgedUnits * isinNavMap[item.isinNo] * isinLTVMap[item.isinNo]);
    });
    return sum;
};
export const getActualLimit = (availableCAS, isinNavMap, isinLTVMap) => {
    let sum = 0;
    availableCAS.forEach((item) => {
        sum =
            sum +
                roundDownToNearestHundred(item.totalAvailableUnits *
                    isinNavMap[item.isinNo] *
                    isinLTVMap[item.isinNo]);
    });
    return sum;
};
export const getPortfolioValue = (availableCAS, isinNavMap) => {
    let sum = 0;
    availableCAS.forEach((item) => {
        sum =
            sum +
                roundDownToNearestHundred(item.totalAvailableUnits * isinNavMap[item.isinNo]);
    });
    return sum;
};
export const TriggerCTA = async (action, _datastore, { navigate, network, setDatastore, showPopup }) => {
    const availableCASMap = await SharedPropsService.getAvailableCASMap();
    const updatedList = [];
    let applicationId = '';
    if (await AsyncStorage.getItem("application_id") !== null) {
        applicationId = await AsyncStorage.getItem("application_id");
    }
    else {
        applicationId = (await SharedPropsService.getUser())
            .linkedApplications[0].applicationId;
    }
    Object.keys(availableCASMap).forEach((key) => {
        const updatedItem = availableCASMap[key];
        updatedList.push(updatedItem);
    });
    await setDatastore(ROUTE.PORTFOLIO, "ContinueButton", {
        loading: true
    });
    const toBeSavedPortfolios = updatedList.filter(item => item.pledgedUnits > 0);
    const toBeSavedPortfolios_SetIsPledgeToTrue = toBeSavedPortfolios.map(item => {
        return {
            ...item,
            is_pledged: true
        };
    });
    const savePortfolio = await network.post(api.savePortfolio, {
        applicationId: applicationId,
        portfolioItemList: toBeSavedPortfolios_SetIsPledgeToTrue,
    }, { headers: await getAppHeader() });
    const stepResponseObject = {
        ...action.payload.value,
        availableCAS: [...updatedList],
    };
    if (savePortfolio?.status === 200) {
        if (await AsyncStorage.getItem("application_id") !== null) {
            await navigate(ROUTE.VERIFY_INTEREST_CHARGES_ENHANCE_LIMIT, { stepResponseObject });
        }
        else {
            navigate(ROUTE.PLEDGE_CONFIRMATION, { stepResponseObject });
        }
    }
    else {
        showPopup({
            title: "We could not save your fund selection because of an internal error",
            type: 'FAILED',
            ctaLabel: 'Retry now',
            ctaAction: {
                routeId: ROUTE.PORTFOLIO,
                type: ACTION.CLOSE_POPUP,
                payload: {}
            },
            primary: true
        });
    }
};
export const goBack = async (action, _datastore, { goBack }) => {
    await goBack();
};
export const EditItem = async (action, _datastore, { navigate }) => {
    navigate(ROUTE.MODIFY_PLEDGED_AMOUNT, {
        index: action.payload.value,
        stepResponseObject: action.payload.stepResponseObject,
        selectedMap: action.payload.selectedMap,
        portfolioSearchKeyword,
    });
};
export const needHelp = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.CONTACT_US_CARD);
};
export const ToggleSelectAction = async (action, _datastore, { setDatastore }) => {
    const isEnhancedLimit = await AsyncStorage.getItem("application_id") !== null && !(await SharedPropsService.getElevateFlow());
    const dynamicCheckLimitFromBE = await allowDynamicLimitFromBE();
    await togglePortfolio(action.payload.value, action.payload.selectedMap[action.payload.value], action.payload.stepResponseObject);
    const props = await portfolioListDatastoreBuilderV2(action.payload.stepResponseObject, portfolioSearchKeyword);
    await setDatastore(ROUTE.PORTFOLIO, "listItem", {
        ...props.listItem,
    });
    await setDatastore(ROUTE.PORTFOLIO, "outOfText1", {
        label: ` ₹${addCommasToNumber(parseInt(removeCommasFromNumber(props.outOfText1["label"].replace("₹", ""))))}`,
    });
    const minimumEligibleLimit = await SharedPropsService.getMinimumEligibleLimitData();
    //@ts-ignore
    const minimumAmount = minimumEligibleLimit?.amount;
    let checkLessLimit;
    if (dynamicCheckLimitFromBE) {
        checkLessLimit = parseInt(removeCommasFromNumber(props.outOfText1["label"].replace("₹", ""))) < minimumAmount;
    }
    else {
        checkLessLimit = isEnhancedLimit ? (parseInt(removeCommasFromNumber(props.outOfText1["label"].replace("₹", ""))) < MIN_LIMIT.ENHANCE_LIMIT)
            : parseInt(removeCommasFromNumber(props.outOfText1["label"].replace("₹", ""))) < 25000;
    }
    if (checkLessLimit) {
        await setDatastore(ROUTE.PORTFOLIO, "ContinueButton", {
            type: ButtonTypeTokens.LargeOutline,
        });
    }
    else {
        await setDatastore(ROUTE.PORTFOLIO, "ContinueButton", {
            type: ButtonTypeTokens.LargeFilled,
        });
    }
    await setDatastore(ROUTE.PORTFOLIO, "outOfText1", {
        ...props.outOfText1,
    });
    const portValue = getDesiredValue(action.payload.stepResponseObject.availableCAS, action.payload.stepResponseObject.isinNAVMap);
    await SharedPropsService.setDesiredPortfolio(portValue);
    await setDatastore(ROUTE.PORTFOLIO, "subTitleText", {
        label: `₹${addCommasToNumber(portValue)} out of ₹${addCommasToNumber(parseInt(action.payload.stepResponseObject["totalPortfolioAmount"].toString()))} are selected for pledging.`,
    });
    const label = `₹${addCommasToNumber(portValue)} out of ₹${addCommasToNumber(parseInt(action.payload.stepResponseObject["totalPortfolioAmount"].toString()))} are selected for pledging.`;
    await setDatastore(ROUTE.SET_CREDIT_LIMIT, "bottomSheetText2", {
        label: `₹${addCommasToNumber(portValue)} out of ₹${addCommasToNumber(parseInt(action.payload.stepResponseObject["totalPortfolioAmount"].toString()))} are selected for pledging.`,
    });
};
export const SearchPortfolio = async (action, _datastore, { setDatastore }) => {
    portfolioSearchKeyword = action.payload.value;
    if (listBeforeSearchUI.length === 0) {
        listBeforeSearchUI = _.get(_datastore, "listItem.data", []);
    }
    const filteredList = listBeforeSearchUI.filter((item) => JSON.stringify(item.label.toUpperCase()).includes(portfolioSearchKeyword.toUpperCase()));
    await setDatastore(ROUTE.PORTFOLIO, "listItem", {
        data: filteredList,
    });
};
export const ClearSearchPortfolio = async (action, _datastore, { setDatastore }) => {
    await setDatastore(ROUTE.PORTFOLIO, "listItem", {
        data: listBeforeSearchUI,
    });
};
export const closePopup = async (action, _datastore, { hidePopup }) => {
    await hidePopup();
};
